import React, { useState } from 'react';
import { Button, ArrowWrapper } from './StyledShowMore';
import { SimpleArrow } from '_utils/icons';
import ScreenReader from '_utils/components/Corporate/ScreenReader';
import PropTypes from 'prop-types';

function ShowMore({ onClick, title, count, label = 'Show more' }) {
  const [showingMore, setShowingMore] = useState(false);

  return (
    <Button
      onClick={(e) => {
        setShowingMore(true);
        onClick(e);
      }}
      aria-expanded={showingMore}
    >
      <span>
        {label} <ScreenReader>{title + ' '}</ScreenReader>({count})
      </span>
      <ArrowWrapper>
        <SimpleArrow ariaHidden={true} />
      </ArrowWrapper>
    </Button>
  );
}

ShowMore.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  label: PropTypes.string,
};

export default ShowMore;
